import type { PaywallPriceScenario } from "@circle-react/types/PaywallPrice";

export interface StatusBadgeProperty {
  className: string;
  labelClassName: string;
  labelLocale: string;
  variant: "secondary" | "info";
}

const trialThenValueClassName = "!bg-blue-100 py-1 px-2";
const trialThenValueLabelClassName = "!text-blue-800 font-medium";

export const priceListProperties: Record<
  PaywallPriceScenario,
  StatusBadgeProperty | null
> = {
  trial_then_value: {
    labelLocale: "price_badge",
    variant: "info",
    className: trialThenValueClassName,
    labelClassName: trialThenValueLabelClassName,
  },
  trial_then_upfront_then_value: {
    labelLocale: "price_badge",
    variant: "info",
    className: trialThenValueClassName,
    labelClassName: trialThenValueLabelClassName,
  },
  upfront_then_trial_then_value: {
    labelLocale: "price_badge",
    variant: "secondary",
    className: "!bg-tertiary text-dark px-2 py-1",
    labelClassName: "!text-primary font-medium",
  },
  value: null,
  upfront_then_value: null,
};

export const previewPriceModalProperties: Record<
  PaywallPriceScenario,
  StatusBadgeProperty | null
> = {
  trial_then_value: {
    labelLocale: "free_trial",
    variant: "info",
    className: trialThenValueClassName,
    labelClassName: trialThenValueLabelClassName,
  },
  trial_then_upfront_then_value: {
    labelLocale: "free_trial",
    variant: "info",
    className: trialThenValueClassName,
    labelClassName: trialThenValueLabelClassName,
  },
  upfront_then_trial_then_value: {
    labelLocale: "paid_trial",
    variant: "secondary",
    className: "!bg-tertiary text-dark px-2 py-1",
    labelClassName: "!text-primary font-medium",
  },
  value: null,
  upfront_then_value: null,
};

export const previewPriceProperties: Record<
  PaywallPriceScenario,
  StatusBadgeProperty | null
> = {
  trial_then_value: {
    labelLocale: "free_trial",
    variant: "info",
    className: trialThenValueClassName,
    labelClassName: trialThenValueLabelClassName,
  },
  trial_then_upfront_then_value: {
    labelLocale: "free_trial",
    className: "!bg-blue-100 py-1 px-2",
    variant: "info",
    labelClassName: trialThenValueLabelClassName,
  },
  upfront_then_trial_then_value: null,
  value: null,
  upfront_then_value: null,
};
